import Admin from 'hive-admin';

import tests from '../../helpers/tests';
import getFilterWithCol from '../../helpers/getFilterWithCol';

import { filterSortCreatedUpdatedName } from '../../components/common';

const getValueForFieldDefault = value => (
  value && value.length
  ? value
  : undefined
);

export const filterSearch = ['FilterField', {
  id: 'search',
  label: null,
  section: 'top',
  buildQuery: (value, builder) => value && builder.add(
    'where',
    { name: { REGEX: value, OPTIONS: 'i' } },
  ),
  getValueForField: value => value || '',
  getValueForQuery: (value) => {
    value = !value
      ? undefined
      : value.target
        ? value.target.value
        : value;
    return !value || !value.length
      ? undefined
      : value;
  },
  field: ['FieldText', {
    name: 'search',
    placeholder: 'Search by name',
  }],
}];

export const filterStore = ['FilterField', {
  id: 'store',
  label: null,
  section: 'top',
  propsFromPage: props => ({ client: props.client }),
  buildQuery: (value, builder) => value && value.length && builder.add(
    'where',
    { store: value },
  ),
  getValueForField: getValueForFieldDefault,
  field: ['FieldConnectionSelect', {
    name: 'store',
    url: '/stores/list',
    placeholder: 'Store',
    allowClear: true,
    searchPaths: ['name'],
  }],
  skip: [Admin.compileFromLibrary(tests.viewerIsNotAdmin)],
}];

export const filterPopulateStore = ['FilterHidden', {
  id: 'filterContentBuilderSegmentPopulateStore',
  build: builder => builder.add('populate', { store: { name: true } }),
}];

export const filterCatalogue = ['FilterHidden', {
  id: 'filterCatalogue',
  build: builder => builder.add('custom', { catalogue: true }),
}];

export const filterPagination = ['FilterPagination', {
  id: 'pagination',
  section: 'bottom',
}];

export const ADMIN = [
  ...[
    [filterSearch, 12],
    [filterSortCreatedUpdatedName, 12],
  ].map(args => getFilterWithCol(...args)),
  filterCatalogue,
  filterPagination,
];

export const COMPONENTS = [
  ...[
    [filterSearch, 12],
    [filterSortCreatedUpdatedName, 12],
  ].map(args => getFilterWithCol(...args)),
  ['FilterHidden', {
    id: 'filterContentBulderSegmentType',
    build: builder => builder.add('where', { type: 'COMPONENT' }),
  }],
  filterCatalogue,
  filterPagination,
];

export const BLOCKS = [
  ...[
    [filterSearch, 8],
    [filterStore, 8],
    [filterSortCreatedUpdatedName, 8],
  ].map(args => getFilterWithCol(...args)),
  ['FilterHidden', {
    id: 'filterContentBulderSegmentType',
    build: builder => builder.add('where', { type: 'BLOCK' }),
  }],
  filterCatalogue,
  filterPopulateStore,
  filterPagination,
];

export const LIBRARY = [
  ...[
    [filterSearch, 12],
    [filterSortCreatedUpdatedName, 12],
  ].map(args => getFilterWithCol(...args)),
  ['FilterHidden', {
    id: 'filterContentBulderSegmentType',
    build: builder => builder.add('where', { type: 'LIBRARY_ITEM' }),
  }],
  filterCatalogue,
  filterPagination,
];
